module.exports = __webpack_public_path__ + "img/mainmenbuttonGREEN4.e6f7c285.png";